<template>
    <div class="security">
        <nav-bar></nav-bar>
        <div :class="isMobile ? 'm-content' : 'content'">
            <div class="box">
                <div class="box-left"  v-if="!isMobile">
                    <p class="title">{{ $t('安全') }}</p>
                    <p class="int">{{ $t('密码重置后，旧密码无效，请记住密码') }}</p>
                </div>
                <div class="box-right">
                    <p class="title">{{ $t('安全') }}</p>
                    <div class="tabs">
                        <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane :label="$t('登录密码')" name="1">
                                <el-input v-model="old_password" :placeholder="$t('请输入原始密码')" show-password></el-input>
                                <el-input v-model="new_password" :placeholder="$t('请输入密码')" show-password></el-input>
                                <el-input v-model="confirm_password" :placeholder="$t('请输入密码')" show-password></el-input>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('提款密码')" name="2">
                                <el-input v-if="!isSet" v-model="old_password" :placeholder="$t('请输入原始密码')" show-password></el-input>
                                <el-input v-model="new_password" :placeholder="$t('请输入密码')" show-password></el-input>
                                <el-input v-model="confirm_password" :placeholder="$t('请输入密码')" show-password></el-input>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <el-button v-if="!isMobile" :disabled="isConfirm" round style="width: 100%;background-color: #000;color: #fff;padding: 15px 0;" @click="submit()">{{ $t('确认') }}</el-button>
                    <el-button v-else :disabled="isConfirm" round style="width: 100%;background-color: rgb(236, 174, 56);color: #fff;padding: 15px 0; "@click="submit()">{{ $t('确认') }}</el-button>
                </div>
            </div>
        </div>
        <footers v-if="!isMobile"></footers>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { setPassword, info } from '../../api/index'
    export default {
        data() {
            return{
                activeName: '1',
                old_password: '',
                new_password: '',
                confirm_password: '',
                isSet: true,
            }
        },
        created() {
            this.getInfo()
        },
        computed: {
            ...mapGetters("device", ["isMobile"]),
            isConfirm() {
                if (this.isSet) {
                    if (this.new_password && this.confirm_password && this.new_password == this.confirm_password) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    if (this.old_password && this.new_password && this.confirm_password && this.new_password == this.confirm_password) {
                        return false
                    } else {
                        return true
                    }
                }
                
            }
        },
        methods: {
            getInfo() {
                info().then(res=> {
                    if (res.code == 0) {
                        this.isSet = res.data.info.pwd2 == 0 ? true : false
                    }
                })
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            submit() {
                setPassword({type:this.activeName,old_pwd:this.old_password,new_pwd: this.new_password}).then(res=> {
                    if (res.code == 0) {
                        this.$message({
                            message: res.info,
                            type: 'success'
                        })
                        this.old_password = ''
                        this.new_password = ''
                        this.confirm_password = ''
                        if (this.activeName == 1) {
                            setTimeout(() => {
                                localStorage.removeItem('token')
                                this.$store.dispatch('login/checkLoginType')
                                this.$router.push('/login')
                            }, 2000);
                        }
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.security {

    .content {
        background: #f8f8f8;
        background-image: linear-gradient(-225deg, #2cd8d5, #c5c1ff 56%, #ffbac3);
        background-position: 0;
        background-size: cover;
        display: flex;
        justify-content: center;
        min-height: 100vh;
        width: 100%;

        .box {
            width: 72%;
            margin: 0 auto 60px auto;
            display: flex;
            padding-top: 60px;

            .box-left {
                flex: 2;
                padding: 40px;

                .title {
                    font-size: 64px;
                    color: #fff;
                    font-weight: 800;
                }

                .int {
                    font-size: 16px;
                    color: #fff;
                    margin: 0;
                }
            }
            .box-right {
                flex: 1;
                padding: 40px;
                background-color: #fff;
                border-radius: 9px;

                .title {
                    font-size: 24px;
                    font-weight: 600;
                    margin: 0 0 15px 0;
                }

                .tabs {
                    width: 100%;

                    :deep(.el-tabs__item) {
                        min-width: 260px;
                        text-align: center;
                        color: #646566;
                    }

                    :deep(.el-tabs__nav-wrap::after) {
                        background-color: transparent;
                    }

                    :deep(.el-tabs__item.is-active) {
                        color: #000;
                    }

                    :deep(.el-tabs__active-bar) {
                        width: 30px !important;
                        left: calc(25% - 25px);
                        background-color: #000;
                        height: 3px;
                    }

                    :deep(.el-input__inner) {
                        margin-bottom: 20px;
                        border-color: #8d8d8d;
                        padding: 20px;
                    }

                    :deep(.el-input__suffix) {
                            top: -10px;
                        }
                }
            }
        }
    }

    .m-content {
        .box {
            display: flex;

            .box-left {
                flex: 2;
                padding: 40px;

                .title {
                    font-size: 64px;
                    color: #fff;
                    font-weight: 800;
                }

                .int {
                    font-size: 16px;
                    color: #fff;
                    margin: 0;
                }
            }
            .box-right {
                flex: 1;
                padding: 30px 10px;
                background-color: #fff;
                border-radius: 9px;

                .title {
                    font-size: 24px;
                    font-weight: 600;
                    margin: 0 0 15px 0;
                }

                .tabs {
                    width: 100%;

                    :deep(.el-tabs__item) {
                        min-width: 150px;
                        text-align: center;
                        color: #646566;
                    }

                    :deep(.el-tabs__nav-wrap::after) {
                        background-color: transparent;
                    }

                    :deep(.el-tabs__item.is-active) {
                        color: #000;
                    }

                    :deep(.el-tabs__active-bar) {
                        width: 30px !important;
                        left: calc(25% - 25px);
                        background-color: #000;
                        height: 3px;
                    }

                    :deep(.el-input__inner) {
                        margin-bottom: 20px;
                        border-color: #8d8d8d;
                        padding: 20px;
                    }

                    :deep(.el-input__suffix) {
                            top: -10px;
                        }
                }
            }
        }
    }
}
</style>